import Profile from './Components/Profile';

function App() {
  return (
    <div className="App">
      <Profile />
    </div>
  );
}

export default App;
